import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SimuladorService {
    private subject = new Subject<any>();

    constructor() {
    }

    cantidadSimuladores(cantidad: number) {
        this.subject.next({simuladores: cantidad});
    }

    getSimuladores(): Observable<any> {
        return this.subject.asObservable();
    }
}
